import { BlockType } from '../../types/index.js';
import { LinkBlock as Component } from './Block.js';
export const RegisteredLinkBlock = (_intl) => ({
    recommendedName: 'Link',
    Component,
    config: { type: BlockType.BuildingBlock },
});
//# sourceMappingURL=registered.js.map